import { render, staticRenderFns } from "./CurrentAsset.vue?vue&type=template&id=772ba524&scoped=true&"
import script from "./CurrentAsset.vue?vue&type=script&lang=js&"
export * from "./CurrentAsset.vue?vue&type=script&lang=js&"
import style0 from "./CurrentAsset.vue?vue&type=style&index=0&id=772ba524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772ba524",
  null
  
)

export default component.exports